var exports = {
  "P": "ProfileCardLayout.module__previewLabel___bWFoTz",
  "K": "ProfileCardLayout.module__profileCard___bWFoTz",
};

module.exports = exports;
